import React from 'react';

const WhatsAppComponent = () => {
  const whatsappBundles = [
    {
      title: '1 DAY WHATSAPP BUNDLE',
      data: '500MB',
      minutes: '',
      price: 'R5'
    },
    {
      title: '7 DAY WHATSAPP BUNDLE',
      data: '700MB',
      minutes: '',
      price: 'R9'
    },
    {
      title: '30 DAY WHATSAPP BUNDLE',
      data: '1GB',
      minutes: '',
      price: 'R19'
    }
  ];

  const styles = {
    container: {
     fontFamily: 'Poppins, sans-serif',
    background: '#3A8181',
      borderRadius: '16px',
      padding: '32px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
      maxWidth: '500px',
      margin: '0 auto',
    },
    header: {
      color: 'white',
      fontSize: '28px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '32px',
      letterSpacing: '1px'
      
    },
    bundleSection: {
      marginBottom: '32px'
    },
    bundleTitle: {
      backgroundColor: '#59C0A1',
      color: 'white',
      fontSize: '14px',
      fontWeight: '600',
      padding: '12px 24px',
      borderRadius: '50px',
      textAlign: 'center',
      marginBottom: '24px',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: '300px'
    },
    bundleContent: {
      display: 'grid',
      gridTemplateColumns: '120px 1fr 80px',
      alignItems: 'center',
      paddingBottom: '16px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
      gap: '20px'
    },
    dataText: {
      color: 'white',
      fontSize: '18px',
      fontWeight: '400',
      textAlign: 'left',
      justifySelf: 'start'
    },
    minutesText: {
      color: 'white',
      fontSize: '18px',
      fontWeight: '400',
      textAlign: 'center',
      justifySelf: 'center'
    },
    priceText: {
      color: 'white',
      fontSize: '18px',
      fontWeight: '400',
      textAlign: 'right',
      justifySelf: 'end'
    }
  };

  const BundleItem = ({ bundle }) => (
    <div style={styles.bundleSection}>
      <div style={styles.bundleTitle}>
        {bundle.title}
      </div>
      <div style={styles.bundleContent}>
        <span style={styles.dataText}>{bundle.data}</span>
        <span style={styles.minutesText}>{bundle.minutes}</span>
        <span style={styles.priceText}>{bundle.price}</span>
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>
        STANDARD RATES
      </h2>
 <p style={{paddingBottom: "20px", textAlign: "center"}}>     <strong>k'nect bundles are available at all tills in-store, via USSD *135# or on Money Market Account.</strong>
      </p>
      <div>
        {whatsappBundles.map((bundle, index) => (
          <BundleItem key={index} bundle={bundle} />
        ))}
      </div>
    </div>
  );
};

export default WhatsAppComponent;